import { render, staticRenderFns } from "./Homework.vue?vue&type=template&id=4f470b78&scoped=true"
import script from "./Homework.vue?vue&type=script&lang=js"
export * from "./Homework.vue?vue&type=script&lang=js"
import style0 from "./Homework.vue?vue&type=style&index=0&id=4f470b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f470b78",
  null
  
)

export default component.exports